import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import al from "./locales/al.json";
import en from "./locales/en.json";

export type Lang = "al" | "en";

const STORAGE_KEY = "lang";

function readStoredLang(): Lang {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "en" ? "en" : "al";
  } catch {
    return "al";
  }
}

i18n.use(initReactI18next).init({
  resources: {
    al: { translation: al },
    en: { translation: en },
  },
  lng: readStoredLang(),
  fallbackLng: "al",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLanguage(lang: Lang) {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
  i18n.changeLanguage(lang);
}

export function intlLocale(): string {
  return i18n.language === "en" ? "en-US" : "sq-AL";
}

export default i18n;
